// App entry: the view state from the address, the audio session, and the shell
// with every registered feature. Features come from src/registry.ts; add a
// register.ts file rather than editing this one.

import "./styles/index.css";
import { buildShell } from "./app/shell";
import { AudioSession } from "./app/controls/audio-session";
import { ViewStore } from "./state/store";
import { bindUrl } from "./state/url-sync";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("index.html has no #app element");

const store = new ViewStore();
bindUrl(store);
const audio = new AudioSession();
buildShell(app, { store, audio });

// Tests wait for this before they look at the page.
document.documentElement.dataset.ready = "true";
